import { render, staticRenderFns } from "./Dash-posts-feed-one.vue?vue&type=template&id=0a33b838"
import script from "./Dash-posts-feed-one.vue?vue&type=script&lang=js"
export * from "./Dash-posts-feed-one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports